<template>
	<div class="user_wbox">
		<div class="inter">
			<div class="div1 t-flex">
				<div class="fr">

					<div class="user_center">

						<div class="user_de_ti" style="margin-bottom: 30px;">账号信息收集</div>

						<div class="edit_pass_word" style="width: auto;">
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									游戏名称(区/服)
								</div>
								<div class="input">
									<el-input v-model="info.game_name" placeholder="请输入游戏名称"></el-input>
								</div>

							</div>
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									操作系统
								</div>
								<div class="input">
									<el-input v-model="info.xitong" placeholder="请输入操作系统"></el-input>
								</div>

							</div>

							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									账号来源(原号主或购买)
								</div>
								<div class="input">
									<el-input v-model="info.laiyuan" placeholder="请输入账号来源"></el-input>
								</div>

							</div>
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									是否支持包赔
								</div>
								<div class="input">
									<el-radio v-model="info.zc_baopei" label="0">不支持</el-radio>
									<el-radio v-model="info.zc_baopei" label="1">支持</el-radio>
								</div>

							</div>
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									有无换绑CD
								</div>
								<div class="input">
									<el-radio v-model="info.huanbang" label="0">无</el-radio>
									<el-radio v-model="info.huanbang" label="1">有</el-radio>
								</div>

							</div>
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									价格
								</div>
								<div class="input">
									<el-input v-model="info.price" type="number" placeholder="请输入价格"></el-input>
								</div>
							</div>
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									服务费
								</div>
								<div class="input" style="color: red;">
									全免
								</div>
							</div>
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									到手价
								</div>
								<div class="input" style="color: red;">
									￥{{info.price}}
								</div>
							</div>
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									账号
								</div>
								<div class="input">
									<el-input v-model="info.acc" placeholder="请输入账号"></el-input>
								</div>

							</div>
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									密码
								</div>
								<div class="input">
									<el-input v-model="info.pass" placeholder="请输入密码"></el-input>
								</div>

							</div>
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									联系人
								</div>
								<div class="input">
									<el-input v-model="info.lx_name" placeholder="请输入联系人"></el-input>
								</div>
							</div>
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									联系电话
								</div>
								<div class="input">
									<el-input v-model="info.lx_mobile" placeholder="请输入联系电话"></el-input>
								</div>
							</div>
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									是否接受砍价
								</div>
								<div class="input">
									<el-radio v-model="info.kanjia" label="0">不接受</el-radio>
									<el-radio v-model="info.kanjia" label="1">接受</el-radio>
								</div>
							</div>
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									是否支持人脸包赔
								</div>
								<div class="input">
									<el-radio v-model="info.renlian" label="0">不支持</el-radio>
									<el-radio v-model="info.renlian" label="1">支持</el-radio>
								</div>
							</div>
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									是否同意全家桶出售模式
								</div>
								<div class="input">
									<el-radio v-model="info.q_sell" label="0">不支持</el-radio>
									<el-radio v-model="info.q_sell" label="1">支持</el-radio>
								</div>
							</div>
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									营地号(腾讯账号专用)其他账号无需填写
								</div>
								<div class="input">
									<el-input v-model="info.yingdi" placeholder="请输入营地ID"></el-input>
								</div>
							</div>
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									有无防沉迷
								</div>
								<div class="input">
									<el-radio v-model="info.fangchengmi" label="0">无</el-radio>
									<el-radio v-model="info.fangchengmi" label="1">有</el-radio>
								</div>
							</div>
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									是否可以二次实名(腾讯账号专用)其他账号无需填写
								</div>
								<div class="input">
									<el-input v-model="info.tengxun" placeholder="请输入"></el-input>
								</div>
							</div>
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									是否处于封号
								</div>
								<div class="input">
									<el-radio v-model="info.fenghao" label="0">否</el-radio>
									<el-radio v-model="info.fenghao" label="1">是</el-radio>
								</div>
							</div>

							<div class="item item1 t-flex t-flex-items-center">
								<div class="lable">
									账号描述
								</div>
								<div class="input">
									<el-input v-model="info.desc" :rows="10" type="textarea"
										placeholder="比如：有什么装备，皮肤等"></el-input>
								</div>
							</div>

							<div class="item item1 t-flex" style="height: auto;">
								<div class="lable">
									上传图片
								</div>
								<div class="shiming">
									<div class="item1">


										<el-upload action="https://api.yihaods.com/api/common/upload"
											list-type="picture-card" :on-success="upidcard1" :on-remove="removeIdcard1">
											<i class="el-icon-plus"></i>
										</el-upload>

									</div>


								</div>
							</div>
							<div style="padding-top: 20px;">
								<div class="debtn" @click="editPass">提交</div>
							</div>

						</div>



					</div>
				</div>
			</div>
		</div>
	</div>

</template>


<script>
	import {
		Notification,
		Message
	} from 'element-ui'
	import moment from 'moment';
	export default {
		data() {
			return {
				list: [],
				content: "",
				active: 2,
				title: "",
				info: {
					game_name: "",
					xitong: "",
					laiyuan: "",
					zc_baopei: "0",
					huanbang: "0",
					acc: "",
					pass: "",
					kanjia: "0",
					lx_name: "",
					lx_mobile: "",
					renlian: "0",
					q_sell: "0",
					yingdi: "",
					fangchengmi: "0",
					price: "",
					tengxun: "",
					desc: "",
					fenghao: "0",
					images: [],
				},

			}
		},
		computed: {
			userinfo() {
				return this.$store.getters.userinfo
			}
		},
		created: function(data) {




		},
		watch: {
			$route() {

			}
		},
		methods: {
			removeIdcard1(file, fileList) {
				this.info.images = fileList
			},

			upidcard1(response, file, fileList) {
				this.info.images = fileList


			},

			editPass() {
				var that = this
				this.rq.requests.post("api/game/user/chushou", that.info).then(res => {

					Message.success({
						message: "提交成功，等待工作人员联系",
						duration: 3000
					})

					location.reload()



				}).catch(error => {
					Message.error({
						message: error.msg,
						duration: 3000
					})
				})

			},


		}


	}
</script>